/**
 * original source: https://ui.shadcn.com/docs/components/skeleton
 */
import { Slot } from './Slot'
import { cn, tv } from '@joyful/utils'
import type { ComponentProps } from 'react'
import type { VariantProps } from '@joyful/utils'

export const skeletonVariants = tv({
  base: 'skeleton-shimmer rounded-md',

  defaultVariants: {
    colorVariant: 'default',
  },

  variants: {
    colorVariant: {
      dark: 'bg-tremor-background-emphasis/5',
      default: 'bg-tremor-background-subtle',
    },
    shape: {
      text: 'inline-block max-w-full rounded-sm align-middle leading-none text-transparent select-none',
    },
  },
})

export interface SkeletonProps
  extends ComponentProps<'div'>, VariantProps<typeof skeletonVariants> {
  /**
   * @default false
   */
  asChild?: boolean
  className?: string
}

/**
 * `shape="text"` renders placeholder words as an invisible inline bar. The
 * surrounding typography sets its height and the words set its width, so the
 * placeholder occupies the same box as the text that replaces it.
 */
export function Skeleton({
  asChild,
  className,
  colorVariant,
  shape,
  ...props
}: SkeletonProps) {
  const Comp = asChild ? Slot : shape === 'text' ? 'span' : 'div'
  return (
    <Comp
      aria-hidden="true"
      className={cn(
        skeletonVariants({
          colorVariant,
          shape,
        }),
        className,
      )}
      {...props}
    />
  )
}
